import React from 'react';

const TermsAndConditions = () => (
  <div className="max-w-3xl mx-auto py-16 px-4">
    <h1 className="text-4xl font-bold mb-4">📄 Terms and Conditions</h1>
    <p className="text-gray-500 mb-2">Last Updated: 25/7/25</p>
    <p className="mb-6">Welcome to BTIndia. These Terms and Conditions govern your use of our services, including recharges, money transfers, and bookings. By accessing or using any part of our platform (<a href="https://mybt.in" className="text-blue-600 underline">https://mybt.in</a>), you agree to be bound by these terms.</p>

    <ol className="list-decimal pl-6 space-y-4">
      <li>
        <strong>General Terms</strong><br />
        You must be at least 18 years of age to use our services.<br />
        All information provided by you must be accurate and complete.<br />
        We reserve the right to modify or terminate services without prior notice.
      </li>
      <li>
        <strong>Recharge Transactions</strong><br />
        All prepaid mobile/DTH recharges are processed instantly.<br />
        BTIndia is not responsible for incorrect numbers or operator selection made by the user.<br />
        Amount once recharged cannot be refunded unless due to technical failure from our side.
      </li>
      <li>
        <strong>Money Transfer</strong><br />
        We only support domestic money transfers within India via verified banking channels.<br />
        You are solely responsible for entering correct beneficiary details.<br />
        Transactions are non-reversible once processed.<br />
        In case of failure, refunds (if applicable) will be processed within 5–7 business days.
      </li>
      <li>
        <strong>Bookings (e.g., Bus, Flights, Hotels)</strong><br />
        All bookings are subject to availability and partner/provider terms.<br />
        Booking once confirmed may be non-refundable or partially refundable, depending on the service provider.<br />
        BTIndia acts as an intermediary and cannot be held liable for third-party service disruptions.
      </li>
      <li>
        <strong>Wallet & Balance</strong><br />
        Any funds added to the wallet are non-withdrawable and can only be used for services within the platform.<br />
        Fraudulent activity may lead to wallet suspension or legal action.
      </li>
      <li>
        <strong>Refund & Cancellation</strong><br />
        Refunds are only processed for failed transactions due to technical errors.<br />
        You must raise a refund request within 48 hours of the transaction.
      </li>
      <li>
        <strong>User Conduct</strong><br />
        You agree not to misuse the platform for illegal or unauthorized purposes.<br />
        Suspicious activity may result in suspension or termination of your account.
      </li>
      <li>
        <strong>Limitation of Liability</strong><br />
        BTIndia is not liable for any indirect, incidental, or consequential damages arising from service usage.<br />
        We do not guarantee uninterrupted access to services, especially during system upgrades or maintenance.
      </li>
      <li>
        <strong>Governing Law</strong><br />
        These terms are governed by the laws of India, and any disputes will be handled in the courts of [Your City/State].
      </li>
      <li>
        <strong>Contact Us</strong><br />
        For support or inquiries, email us at: <a href="mailto:support@mybt.in" className="text-blue-600 underline">support@mybt.in</a>
      </li>
    </ol>
  </div>
);

export default TermsAndConditions;
